module.exports = __webpack_public_path__ + "static/TimiskamingHealthUnit-logo-5292b15d185b2879b74168c5c9cecdd3.jpg";